//Merge integrations
import coachSSO from '../../coachSSO/lan/en';

const locales = {
  ...coachSSO,
};

export default locales;
